module.exports = __webpack_public_path__ + "frontend/images/devise-singup-xs-127a807bd22aa7b7bf0bad39d75110d1.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/frontend/images/devise-singup-xs.jpg
// module id = 334
// module chunks = 2